import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const FeedbackLoopContext = createContext(null);

type Props = {
  children: ReactElement;
};

const FeedbackLoopProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.post(
        `tm/transactions/${payload.id}/prediction-feedback`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <FeedbackLoopContext.Provider value={contextValue}>
      {children}
    </FeedbackLoopContext.Provider>
  );
};

export default FeedbackLoopProvider;
